import type { ColumnDef } from '@tanstack/react-table';
import { useCallback } from 'react';
import { useSafeLocalStorage, useStorageKey } from '../../../../tools/storage.js';
import { getRowRecords } from '../../_shared/getSelectedRowIds.js';

type UseColumnVisibilityProps<TData, TValue> = {
    id: string;
    columns: ColumnDef<TData, TValue>[];
};

export function useColumnVisibility<TData, TValue>({ id, columns }: UseColumnVisibilityProps<TData, TValue>) {
    const localStorageKey = useStorageKey({
        base: 'resizable-table',
        utility: 'column-visibility',
        id,
        version: 1,
    });

    const [columnVisibility, setColumnVisibility] = useSafeLocalStorage<Record<string, boolean>>(
        localStorageKey,
        () => {
            return getRowRecords(columns.map((column) => column.id).filter((id) => id !== undefined));
        }
    );

    const resetColumnVisibility = useCallback(() => {
        setColumnVisibility(getRowRecords(columns.map((column) => column.id).filter((id) => id !== undefined)));
    }, [columns, setColumnVisibility]);

    return {
        columnVisibility,
        setColumnVisibility,
        resetColumnVisibility,
    };
}
